import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    allItems: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getAllItems(state) {
      return state.allItems;
    },
    getSelectedItems(state) {
      return state.items.map((type_alarm) => ({
        value: type_alarm.id,
        label: type_alarm.name,
        id_type_alarms: type_alarm?.type_alarms?.map(typeAlarm => typeAlarm.id) || [],
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setAllItems(state, value) {
      state.allItems = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      params.max = 1000;
      const response = await axios.get("v1/type_alarm_category", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }

      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "type-alarm",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de categoría de tipo de alarma",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/type_alarm_category", params);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/type_alarm_category/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/type_alarm_category/${id}`);

      return data;
    },
    async getAllUnpaginated({ commit }) {
      const response = await axios.get("v1/type_alarm_category");

      if (!response.data?.data) {
        return [];
      }

      const filteredItems = response.data.data.map((item) => ({
        id: item.id,
        description: item.description,
        color: item.color,
        text_color: item.text_color,
        color_icon: item.color_icon,
        icon: item.icon,
      }));

      commit("setAllItems", filteredItems);
      return filteredItems;
    },
    clear({ commit }) {
      commit("setData", []);
      commit("setAllItems", []);
    },
  },
};
